import { RoutesEnum } from '@/enum/routes.enum';

import { LoginWithTokenRes } from '@/types/domain';

export const takeRedirectionLink = (data: LoginWithTokenRes): string | null =>
  !data.username ? RoutesEnum.USERNAME_UPDATE : null;
